import React from 'react';
import './WhatsAppButton.css';

const WhatsAppButton: React.FC = () => {

  return (
    <a 
      href={`https://wa.me/919619575441`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button" 
      title="Chat with us on WhatsApp"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
};

export default WhatsAppButton;
